import PLAYLIST_TYPE from '../constants/PlaylistType';
import PLAYLIST_ITEM_TYPE from '../constants/PlaylistItemType';
import TizenVideoProcessor from '../helpers/Playlist/VideoProcessor/TizenVideoProcessor';
import WebosVideoProcessor from '../helpers/Playlist/VideoProcessor/WebosVideoProcessor';
import AudioProcessor from '../helpers/Playlist/AudioProcessor/AudioProcessor';
import InfoscreenConfig from '../config';

const IMAGE_TYPES = ['jpeg', 'png'];
const VIDEO_TYPES = ['mp4'];
const AUDIO_TYPES = ['mpeg'];
const WEATHER_WIDGET_TYPES = ['weather_forecast'];
const TEXT_WIDGET_TYPES = ['text'];

function getVideoProcessor() {
  const tizenNavigators = ['Tizen', 'AppleWebKit/537.42+'];

  const navigatorCurrentVersion = window.navigator.appVersion.toLowerCase();

  const isTizen = tizenNavigators.some((navigator) => {
    const navigatorVersion = navigator.toLowerCase();
    return navigatorCurrentVersion.indexOf(navigatorVersion) !== -1;
  });

  if (isTizen) return TizenVideoProcessor;

  return WebosVideoProcessor;
}

export default {
  props: {
    playlist: {
      type: Object,
      default: null,
    },
    playlistType: {
      type: String,
      default: PLAYLIST_TYPE.MAIN,
    },
  },
  watch: {
    playlistItems: {
      handler: function () {
        if (this.playlistItems.length) {
          this.$nextTick(() => {
            this.prepareVideo();
            this.prepareAudio();
          });

          this.nextPlaylistItem();
        } else {
          this.currentPlaylistItem = null;
        }
      },
      immediate: true,
    },
  },
  data() {
    return {
      currentPlaylistItem: null,
      currentPlaylistItemId: -1,
      videoProcessor: null,
      audioProcessor: null,
    };
  },
  methods: {
    prepareVideo() {
      const { video1, video2 } = this.$refs;

      for (const video of [video1, video2]) {
        if (!video) return;
        this.createVideo(video);
      }

      const TargetVideoProcessor = getVideoProcessor();
      this.videoProcessor = new TargetVideoProcessor(this.$refs.video1, this.$refs.video2, { skipIntervalSec: InfoscreenConfig.PLAYLIST_SKIP_INTERVAL_SEC });

      this.videoProcessor.emitter.subscribe('video:play', (video) => {
        this.showElement(video);
      });

      this.videoProcessor.emitter.subscribe('video:error', ({video, error}) => {
        console.error(video, error);
      });

      this.videoProcessor.emitter.subscribe('video:ended', (video) => {
        console.log(`${video.id} ended`);
        this.nextPlaylistItem();
      });

      this.videoProcessor.emitter.subscribe('video:unmute', (video) => {
        this.unmuteVideo(video);
      });
    },
    createVideo(video) {
      if (this.playlistType === PLAYLIST_TYPE.ADDITIONAL) {
        video.noaudio = true;
      }
    },
    prepareAudio() {
      this.audioProcessor = new AudioProcessor(this.$refs.audio, { skipIntervalSec: InfoscreenConfig.PLAYLIST_SKIP_INTERVAL_SEC });

      this.audioProcessor.emitter.subscribe('audio:play', (audio) => {
        this.unmuteAudio(audio);
      });
      this.audioProcessor.emitter.subscribe('audio:ended', (audio) => {
        console.info(`audio ${audio.src} is ended`);
        this.nextPlaylistItem();
      });
    },
    getNextPlaylistItemId() {
      return this.currentPlaylistItemId + 1 >= this.playlistItems.length ? 0 : this.currentPlaylistItemId += 1;
    },
    getMediaType(playlistItem) {
      if (playlistItem.widget) {
        const widgetType = playlistItem.widget.name;

        if (WEATHER_WIDGET_TYPES.includes(widgetType)) return PLAYLIST_ITEM_TYPE.WEATHER_WIDGET;
        if (TEXT_WIDGET_TYPES.includes(widgetType)) return PLAYLIST_ITEM_TYPE.TEXT_WIDGET;
      } else if (playlistItem.media) {
        const mediaItemtype = playlistItem.media.type;
        if (IMAGE_TYPES.includes(mediaItemtype)) return PLAYLIST_ITEM_TYPE.IMAGE;
        if (VIDEO_TYPES.includes(mediaItemtype)) return PLAYLIST_ITEM_TYPE.VIDEO;
        if (AUDIO_TYPES.includes(mediaItemtype)) return PLAYLIST_ITEM_TYPE.AUDIO;
        if (mediaItemtype === PLAYLIST_ITEM_TYPE.LINK) return PLAYLIST_ITEM_TYPE.LINK;
      }

      console.warn(`Тип элемента плейлиста не определён`, playlistItem);

      return null;
    },
  },
};
